import { InjectionToken } from '@angular/core';
import { RegisterName } from './register.model';

export const REGISTER_NAME_TOKEN = new InjectionToken<RegisterName>('REGISTER_NAME_TOKEN');
